query CardAccountAvailableTags($id: UUID!) {
  cardAccountAvailableTags(entityId: $id) {
    nodes {
      id
      name
      badgeName
      badgeColor
    }
  }
}
